// extracted by mini-css-extract-plugin
module.exports = {"card":"style_card__3RAm7","chart":"style_chart__2LxEQ","amount":"style_amount__G8gsN","title":"style_title__1_T9-"};